module.exports = __webpack_public_path__ + "cb352f1a5ab908c0952c34619a744b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cancel.png
// module id = 994
// module chunks = 0